import setpAlertAgendaPrices from '../components/alert-agenda-prices'
import setpAlertAgendaAddress from '../components/alert-agenda-address'
import setpAlertNextStep from '../components/alert-next-step'

export default {
  setpAlertAgendaPrices,
  setpAlertAgendaAddress,
  setpAlertNextStep
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/resources/components.js